// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatWidget_chatWidget__uz1Ih {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 9999;
  font-family: 'Poppins', system-ui, sans-serif;
}

/* ── Toggle button ──────────────────────────────────────────────── */
.ChatWidget_chatToggle__TtLYM {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  background-color: #3F97A0;
  color: #ffffff;
  border: none;
  border-radius: 0;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(20, 20, 20, 0.18);
  transition: background-color 0.25s ease, transform 0.2s ease;
}

.ChatWidget_chatToggle__TtLYM:hover {
  background-color: #1A1A1A;
  transform: translateY(-1px);
}

.ChatWidget_chatToggle__TtLYM:focus-visible {
  outline: 2px solid #1A1A1A;
  outline-offset: 3px;
}

.ChatWidget_chatToggle__TtLYM svg {
  width: 22px;
  height: 22px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ── Chat panel ─────────────────────────────────────────────────── */
.ChatWidget_chatWindow__N6pN- {
  position: absolute;
  bottom: 68px;
  right: 0;
  width: 340px;
  max-width: calc(100vw - 56px);
  height: 420px;
  background: #ffffff;
  border-top: 2px solid #3F97A0;
  box-shadow: 0 18px 40px rgba(20, 20, 20, 0.18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: ChatWidget_fadeInUp__jEmdl 0.25s ease;
}

.ChatWidget_chatHeader__nYsvi {
  background-color: #1A1A1A;
  color: #ffffff;
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ChatWidget_chatHeaderTitle__DPAIS {
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.ChatWidget_closeBtn__2Splk {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  color: #ffffff;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s ease;
}

.ChatWidget_closeBtn__2Splk:hover {
  color: #3F97A0;
}

.ChatWidget_chatBody__lQB5Y {
  flex: 1 1;
  padding: 18px;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.7;
  color: #1A1A1A;
  overflow-y: auto;
  background-color: #F7F5F2;
}

.ChatWidget_placeholder__iXBmS {
  color: #7A736B;
  text-align: center;
  margin: 40px 0 0;
  font-size: 13px;
}

.ChatWidget_msgUser__CRUoF,
.ChatWidget_msgBot__hWU7A {
  max-width: 80%;
  margin-bottom: 10px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.55;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.ChatWidget_msgUser__CRUoF {
  margin-left: auto;
  background-color: #1A1A1A;
  color: #ffffff;
  border-radius: 4px 4px 0 4px;
}

.ChatWidget_msgBot__hWU7A {
  margin-right: auto;
  background-color: #ffffff;
  color: #1A1A1A;
  border: 1px solid #D8D3CD;
  border-radius: 4px 4px 4px 0;
}

.ChatWidget_typing__Rs2Qb {
  display: inline-block;
  letter-spacing: 4px;
  font-size: 18px;
  line-height: 1;
  color: #7A736B;
  animation: ChatWidget_blink__JQClO 1.2s infinite;
}

@keyframes ChatWidget_blink__JQClO {
  0%, 100% { opacity: 0.3; }
  50%      { opacity: 1; }
}

.ChatWidget_chatInput__0XQm5 {
  padding: 12px 14px;
  border-top: 1px solid #D8D3CD;
  background-color: #ffffff;
}

.ChatWidget_chatInput__0XQm5 input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #D8D3CD;
  border-radius: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: #1A1A1A;
  outline: none;
  transition: border-color 0.2s ease;
}

.ChatWidget_chatInput__0XQm5 input:focus {
  border-color: #3F97A0;
}

/* ── Animation ──────────────────────────────────────────────────── */
@keyframes ChatWidget_fadeInUp__jEmdl {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BubbleChat/ChatWidget.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,6CAA6C;AAC/C;;AAEA,sEAAsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gDAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gDAA8B;AAChC;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,WAAW,UAAU,EAAE;AACzB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".chatWidget {\n  position: fixed;\n  bottom: 28px;\n  right: 28px;\n  z-index: 9999;\n  font-family: 'Poppins', system-ui, sans-serif;\n}\n\n/* ── Toggle button ──────────────────────────────────────────────── */\n.chatToggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  background-color: #3F97A0;\n  color: #ffffff;\n  border: none;\n  border-radius: 0;\n  cursor: pointer;\n  box-shadow: 0 8px 24px rgba(20, 20, 20, 0.18);\n  transition: background-color 0.25s ease, transform 0.2s ease;\n}\n\n.chatToggle:hover {\n  background-color: #1A1A1A;\n  transform: translateY(-1px);\n}\n\n.chatToggle:focus-visible {\n  outline: 2px solid #1A1A1A;\n  outline-offset: 3px;\n}\n\n.chatToggle svg {\n  width: 22px;\n  height: 22px;\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 1.5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* ── Chat panel ─────────────────────────────────────────────────── */\n.chatWindow {\n  position: absolute;\n  bottom: 68px;\n  right: 0;\n  width: 340px;\n  max-width: calc(100vw - 56px);\n  height: 420px;\n  background: #ffffff;\n  border-top: 2px solid #3F97A0;\n  box-shadow: 0 18px 40px rgba(20, 20, 20, 0.18);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: fadeInUp 0.25s ease;\n}\n\n.chatHeader {\n  background-color: #1A1A1A;\n  color: #ffffff;\n  padding: 14px 18px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.chatHeaderTitle {\n  font-family: 'Poppins', sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 22px;\n  line-height: 1;\n  color: #ffffff;\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.2s ease;\n}\n\n.closeBtn:hover {\n  color: #3F97A0;\n}\n\n.chatBody {\n  flex: 1;\n  padding: 18px;\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 1.7;\n  color: #1A1A1A;\n  overflow-y: auto;\n  background-color: #F7F5F2;\n}\n\n.placeholder {\n  color: #7A736B;\n  text-align: center;\n  margin: 40px 0 0;\n  font-size: 13px;\n}\n\n.msgUser,\n.msgBot {\n  max-width: 80%;\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  font-size: 13px;\n  line-height: 1.55;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.msgUser {\n  margin-left: auto;\n  background-color: #1A1A1A;\n  color: #ffffff;\n  border-radius: 4px 4px 0 4px;\n}\n\n.msgBot {\n  margin-right: auto;\n  background-color: #ffffff;\n  color: #1A1A1A;\n  border: 1px solid #D8D3CD;\n  border-radius: 4px 4px 4px 0;\n}\n\n.typing {\n  display: inline-block;\n  letter-spacing: 4px;\n  font-size: 18px;\n  line-height: 1;\n  color: #7A736B;\n  animation: blink 1.2s infinite;\n}\n\n@keyframes blink {\n  0%, 100% { opacity: 0.3; }\n  50%      { opacity: 1; }\n}\n\n.chatInput {\n  padding: 12px 14px;\n  border-top: 1px solid #D8D3CD;\n  background-color: #ffffff;\n}\n\n.chatInput input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #D8D3CD;\n  border-radius: 0;\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  color: #1A1A1A;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.chatInput input:focus {\n  border-color: #3F97A0;\n}\n\n/* ── Animation ──────────────────────────────────────────────────── */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatWidget": `ChatWidget_chatWidget__uz1Ih`,
	"chatToggle": `ChatWidget_chatToggle__TtLYM`,
	"chatWindow": `ChatWidget_chatWindow__N6pN-`,
	"fadeInUp": `ChatWidget_fadeInUp__jEmdl`,
	"chatHeader": `ChatWidget_chatHeader__nYsvi`,
	"chatHeaderTitle": `ChatWidget_chatHeaderTitle__DPAIS`,
	"closeBtn": `ChatWidget_closeBtn__2Splk`,
	"chatBody": `ChatWidget_chatBody__lQB5Y`,
	"placeholder": `ChatWidget_placeholder__iXBmS`,
	"msgUser": `ChatWidget_msgUser__CRUoF`,
	"msgBot": `ChatWidget_msgBot__hWU7A`,
	"typing": `ChatWidget_typing__Rs2Qb`,
	"blink": `ChatWidget_blink__JQClO`,
	"chatInput": `ChatWidget_chatInput__0XQm5`
};
export default ___CSS_LOADER_EXPORT___;
